import styles from "./resource-links.module.scss";

export default function ResourceLinks({ ctaData, faqs }) {
  const ctaTypes = {
    "Download Related Files": {
      isDownload: true,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.75 13.6875C4.06066 13.6875 4.3125 13.9393 4.3125 14.25V18.75C4.3125 18.8536 4.39645 18.9375 4.5 18.9375H19.5C19.6036 18.9375 19.6875 18.8536 19.6875 18.75V14.25C19.6875 13.9393 19.9393 13.6875 20.25 13.6875C20.5607 13.6875 20.8125 13.9393 20.8125 14.25V18.75C20.8125 19.4749 20.2249 20.0625 19.5 20.0625H4.5C3.77513 20.0625 3.1875 19.4749 3.1875 18.75V14.25C3.1875 13.9393 3.43934 13.6875 3.75 13.6875Z"
            fill="#6C5CE7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.9775 13.318L12.3977 16.8977C12.1781 17.1174 11.8219 17.1174 11.6023 16.8977L8.02252 13.318C7.80285 13.0983 7.80285 12.7422 8.02252 12.5225C8.24219 12.3029 8.59835 12.3029 8.81802 12.5225L11.4375 15.142L11.4375 4.5C11.4375 4.18934 11.6893 3.9375 12 3.9375C12.3107 3.9375 12.5625 4.18934 12.5625 4.5L12.5625 15.142L15.182 12.5225C15.4017 12.3029 15.7578 12.3029 15.9775 12.5225C16.1971 12.7422 16.1971 13.0983 15.9775 13.318Z"
            fill="#6C5CE7"
          />
        </svg>
      ),
    },

    "Code Samples": {
      isDownload: true,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.25 2.4375C14.5607 2.4375 14.8125 2.68934 14.8125 3V7.6875H19.5C19.8107 7.6875 20.0625 7.93934 20.0625 8.25C20.0625 8.56066 19.8107 8.8125 19.5 8.8125H14.25C13.9393 8.8125 13.6875 8.56066 13.6875 8.25V3C13.6875 2.68934 13.9393 2.4375 14.25 2.4375Z"
            fill="#6C5CE7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.4773 11.6023C13.6969 11.3826 14.0531 11.3826 14.2727 11.6023L16.5227 13.8523C16.7424 14.0719 16.7424 14.4281 16.5227 14.6477L14.2727 16.8977C14.0531 17.1174 13.6969 17.1174 13.4773 16.8977C13.2576 16.6781 13.2576 16.3219 13.4773 16.1023L15.3295 14.25L13.4773 12.3977C13.2576 12.1781 13.2576 11.8219 13.4773 11.6023Z"
            fill="#6C5CE7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.5227 11.6023C10.7424 11.8219 10.7424 12.1781 10.5227 12.3977L8.6705 14.25L10.5227 16.1023C10.7424 16.3219 10.7424 16.6781 10.5227 16.8977C10.3031 17.1174 9.94692 17.1174 9.72725 16.8977L7.47725 14.6477C7.25758 14.4281 7.25758 14.0719 7.47725 13.8523L9.72725 11.6023C9.94692 11.3826 10.3031 11.3826 10.5227 11.6023Z"
            fill="#6C5CE7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.32192 2.82192C4.56806 2.57578 4.9019 2.4375 5.25 2.4375H14.25C14.3992 2.4375 14.5423 2.49676 14.6477 2.60225L19.8977 7.85225C20.0032 7.95774 20.0625 8.10082 20.0625 8.25V20.25C20.0625 20.5981 19.9242 20.9319 19.6781 21.1781C19.4319 21.4242 19.0981 21.5625 18.75 21.5625H5.25C4.9019 21.5625 4.56806 21.4242 4.32192 21.1781C4.07578 20.9319 3.9375 20.5981 3.9375 20.25V3.75C3.9375 3.4019 4.07578 3.06806 4.32192 2.82192ZM5.25 3.5625C5.20027 3.5625 5.15258 3.58225 5.11742 3.61742C5.08225 3.65258 5.0625 3.70027 5.0625 3.75V20.25C5.0625 20.2997 5.08225 20.3474 5.11742 20.3826C5.15258 20.4177 5.20027 20.4375 5.25 20.4375H18.75C18.7997 20.4375 18.8474 20.4177 18.8826 20.3826C18.9177 20.3474 18.9375 20.2997 18.9375 20.25V8.483L14.017 3.5625H5.25Z"
            fill="#6C5CE7"
          />
        </svg>
      ),
    },

    "Exercise Files": {
      isDownload: true,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.25 3.5625C5.20027 3.5625 5.15258 3.58225 5.11742 3.61742C5.08225 3.65258 5.0625 3.70027 5.0625 3.75V20.25C5.0625 20.2997 5.08225 20.3474 5.11742 20.3826C5.15258 20.4177 5.20027 20.4375 5.25 20.4375H18.75C18.7997 20.4375 18.8474 20.4177 18.8826 20.3826C18.9177 20.3474 18.9375 20.2997 18.9375 20.25V8.483L14.017 3.5625H5.25ZM4.32192 2.82192C4.56806 2.57578 4.9019 2.4375 5.25 2.4375H14.25C14.3992 2.4375 14.5423 2.49676 14.6477 2.60225L19.8977 7.85225C20.0032 7.95774 20.0625 8.10082 20.0625 8.25V20.25C20.0625 20.5981 19.9242 20.9319 19.6781 21.1781C19.4319 21.4242 19.0981 21.5625 18.75 21.5625H5.25C4.9019 21.5625 4.56806 21.4242 4.32192 21.1781C4.07578 20.9319 3.9375 20.5981 3.9375 20.25V3.75C3.9375 3.4019 4.07578 3.06806 4.32192 2.82192Z"
            fill="#6C5CE7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.25 2.4375C14.5607 2.4375 14.8125 2.68934 14.8125 3V7.6875H19.5C19.8107 7.6875 20.0625 7.93934 20.0625 8.25C20.0625 8.56066 19.8107 8.8125 19.5 8.8125H14.25C13.9393 8.8125 13.6875 8.56066 13.6875 8.25V3C13.6875 2.68934 13.9393 2.4375 14.25 2.4375Z"
            fill="#6C5CE7"
          />
        </svg>
      ),
    },
  };
  return (
    <ul className={styles["icon-links"]}>
      {ctaData
        ?.filter((el) => el.type !== "View FAQ")
        .map((el, index) => {
          const item = ctaTypes[el?.type];

          return (
            <>
              {item?.isDownload && el?.file ? (
                <li
                  className={styles["li-icon-link"]}
                  key={index}
                >
                  <a
                    className={styles["icon-link"]}
                    href={el?.file?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Open ${el?.type} in new tab`}
                  >
                    <span className={styles["icon"]}>{item?.icon}</span>
                    <span className={styles["label"]}>{el?.type}</span>
                  </a>
                </li>
              ) : null}
              {el?.type === "Custom CTA" ? (
                <li
                  className={styles["li-icon-link"]}
                  key={index}
                >
                  <a
                    className={styles["icon-link"]}
                    href={el?.url || el?.file?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Open ${el.custom_type} in new tab`}
                  >
                    {(el?.custom_icon && (
                      <span className={styles["icon"]}>
                        {" "}
                        <img
                          src={el?.custom_icon.url}
                          alt="custom-icon"
                        />
                      </span>
                    )) ||
                      (el?.file?.url && (
                        <span className={styles["icon"]}>
                          {ctaTypes["Download Related Files"]?.icon}
                        </span>
                      )) ||
                      (el?.url && (
                        <span className={styles["icon"]}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="24px"
                            viewBox="0 -960 960 960"
                            width="24px"
                            fill="#6C5CE7"
                          >
                            <path d="M224.62-160q-27.62 0-46.12-18.5Q160-197 160-224.62v-510.76q0-27.62 18.5-46.12Q197-800 224.62-800h224.61v40H224.62q-9.24 0-16.93 7.69-7.69 7.69-7.69 16.93v510.76q0 9.24 7.69 16.93 7.69 7.69 16.93 7.69h510.76q9.24 0 16.93-7.69 7.69-7.69 7.69-16.93v-224.61h40v224.61q0 27.62-18.5 46.12Q763-160 735.38-160H224.62Zm164.92-201.23-28.31-28.31L731.69-760H560v-40h240v240h-40v-171.69L389.54-361.23Z" />
                          </svg>
                        </span>
                      ))}
                    <span className={styles["label"]}>{el.custom_type}</span>
                  </a>
                </li>
              ) : null}
            </>
          );
        })}
    </ul>
  );
}
